import { useEffect, useState, useMemo } from "react";
import axiosInstance from "config/axiosInstance";
import { Card } from "@mui/material";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import LineChart from "examples/Charts/LineCharts/LineChart";

function SalesOverview() {
  const [monthlyData, setMonthlyData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMonthlyData = async () => {
      try {
        const res = await axiosInstance.get("/dashboard/monthly-stats");

        if (res.data?.success) {
          setMonthlyData(res.data.monthly || []);
        }
        setLoading(false);
      } catch (err) {
        setLoading(false);
      }
    };

    fetchMonthlyData();
  }, []);

  const lineChartData = useMemo(() => {
    // Always show all 12 months
    const monthNames = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];
    const currentYear = new Date().getFullYear();
    
    // Create a map of month -> total from the backend data
    const dataMap = {};
    if (monthlyData && monthlyData.length > 0) {
      monthlyData.forEach((item) => {
        // Only use current year data
        if (item.year === currentYear) {
          dataMap[item.month] = Number(item.total || 0);
        }
      });
    }

    // Build data for all 12 months (1-12)
    const data = [];
    for (let month = 1; month <= 12; month++) {
      data.push(dataMap[month] || 0);
    }

    return {
      series: [
        {
          name: "Ingresos (S/.)",
          data: data,
        },
      ],
      options: {
        chart: {
          toolbar: { show: false },
          type: "area",
        },
        stroke: {
          curve: "smooth",
          width: 3,
        },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.2,
            stops: [0, 90, 100],
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: monthNames,
          labels: {
            style: {
              colors: "#cbd5e1",
              fontSize: "12px",
            },
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              return `S/. ${Number(val || 0).toLocaleString('es-PE', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
            },
            style: {
              colors: "#cbd5e1",
              fontSize: "12px",
            },
          },
        },
        colors: ["#00c853"],
        tooltip: {
          theme: "dark",
          y: {
            formatter: function (val) {
              return `S/. ${Number(val || 0).toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
            },
          },
        },
        grid: {
          borderColor: "rgba(255, 255, 255, 0.1)",
          strokeDashArray: 5,
        },
        markers: {
          size: 0,
        },
      },
    };
  }, [monthlyData]);

  return (
    <Card>
      <VuiBox p={3}>
        <VuiBox mb={3}>
          <VuiTypography variant="lg" color="white" fontWeight="bold">
            Resumen de Ventas
          </VuiTypography>
          <VuiTypography variant="button" color="text" fontWeight="regular">
            Ingresos mensuales del año {new Date().getFullYear()}
          </VuiTypography>
        </VuiBox>
        <VuiBox sx={{ height: "310px" }}>
          {loading ? (
            <VuiTypography variant="button" color="text">
              Cargando...
            </VuiTypography>
          ) : (
            <LineChart
              lineChartData={lineChartData.series}
              lineChartOptions={lineChartData.options}
            />
          )}
        </VuiBox>
      </VuiBox>
    </Card>
  );
}

export default SalesOverview;
